import Markdown from 'markdown-to-jsx'
import styles from './highlight.module.css'
import Image from 'next/image'


export default function HighlightCard({ data }) {
  return (
    <div className={styles.card}>
      <div>
          <img
            loading="lazy"
            src={data.imagem_card.url}
            // width={54}
            // height={54}
          />
      </div>
      <div className={styles.text}>
        <Markdown>{data.descricao}</Markdown>
      </div>
    </div>
  )
}
